// Pre-order pricing rules — MUST match backend server.py::pre_order_deposit_gbp
// Every item in the shop is a pre-order. Deposit tiers:
//   full price  < £1000  →  £55  deposit
//   full price >= £1000  →  £100 deposit
export const PRE_ORDER_HIGH_THRESHOLD = 1000;
export const PRE_ORDER_DEPOSIT_LOW = 55;
export const PRE_ORDER_DEPOSIT_HIGH = 100;

export const preOrderDeposit = (fullPrice) => {
  const p = Number(fullPrice || 0);
  return p >= PRE_ORDER_HIGH_THRESHOLD ? PRE_ORDER_DEPOSIT_HIGH : PRE_ORDER_DEPOSIT_LOW;
};

export const preOrderBalance = (fullPrice) => {
  const p = Number(fullPrice || 0);
  return Math.max(0, p - preOrderDeposit(p));
};

export const fmtGBP = (n) => `£${Number(n || 0).toFixed(2)}`;
